module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_1.7143b5cc.png";